<div class="atr-activation-popup" [style.width]="POPUP_DEFAULTS.WIDTH">
  <h1 class="atr-activation-popup-title">{{ 'AtrActivationPopup.Title' | translate }}</h1>
  <p class="atr-activation-popup-body">{{ 'AtrActivationPopup.Body' | translate }}</p>

  <div class="flex justify-end gap-2 mt-4">
    <tar-icon-button
      type="secondary"
      [label]="'AtrActivationPopup.GoToKnowledgeBase' | translate"
      (click)="onGoToKnowledgeBase()"
    />
    <tar-icon-button
      type="primary"
      icon=""
      [label]="'AtrActivationPopup.Understood' | translate"
      (click)="onUnderstood()"
    />
  </div>
</div>
